OE.addPlugin('Collapsable', (function(){

    /**
     * @namespace OE.Plugins.Collapsable
     *
     * @description		Takes all <code>[data-oe-collapsable]</code> elements and makes their
     * <code>.collapsable__content</code> child element collapsable. By default all
     * collapsable elements are collapsed - add <code>.is--expanded</code> if
     * you need the element to be expanded by default.
     *
     * On initialization a delegating event is added to <code>.collapsable__title</code>
     * elements which will toggle the collapsable element by click (touchstart).
     *
     * If many <code>.collapsable</code> elements are grouped within an element and a
     * single <code>.collapsable</code> element has a <code>.collapsable-single</code> class,
     * it will collapse all other <code>.collapsable</code>s found in the group.
     *
     * The {@link <%= jsnamespace %>.collapsables~resize|<%= jsnamespace %>.collapsable.resize()} function will
     * trigger a collection of events any other function can hook in:
     * * <code><%= jsnamespace %>.collapsables.start</code> is triggered when a collapsing transition of .collapsable is starting (passing the value of {show} to the attached function)
     * * <code><%= jsnamespace %>.collapsables.start_item</code> is triggered each time a .collapsing-content element transition starts (passing the particular .collapsing-content and the value of {show} to the attached function)
     * * <code><%= jsnamespace %>.collapsables.end_item</code> is triggered each time a .collapsing-content element transition ends (passing the particular .collapsing-content and the value of {show} to the attached function)
     * * <code><%= jsnamespace %>.collapsables.end</code> is triggered when a collapsing transition of .collapsable has ended (passing the value of {show} to the attached function)
     * * <code><%= jsnamespace %>.collapsables.running</code> while thecollapsing transition runs (each 10ms) (passing the value of {show} to the attached function)
     *
     * @example <caption>A simple single collapsable element</caption>
     * <div id="collapsing-element" class="collapsable">
     *   <p class="collapsing-title">This expands and collapses the content</p>
     *   <p class="collapsing-content">This is the collapsing content</p>
     * </div>
     *
     * @example <caption>A group of collapsable elements</caption>
     * <div>
     *   <div id="collapsing-element" class="collapsable uncollapsed">
     *     <!-- This element will be expanded by default //-->
     *     <p class="collapsing-title">This expands and collapses the content</p>
     *     <p class="collapsing-content">This is the collapsing content</p>
     *   </div>
     *
     *   <!-- When this element is expanded, all other sibling elements will be collapsed //-->
     *   <div id="collapsing-element" class="collapsable collapsable-single">
     *     <p class="collapsing-title">This expands and collapses the content</p>
     *     <p class="collapsing-content">This is the collapsing content</p>
     *   </div>
     *
     *   <div id="collapsing-element" class="collapsable">
     *     <p class="collapsing-title">This expands and collapses the content</p>
     *     <p class="collapsing-content">This is the collapsing content</p>
     *   </div>
     * </div>
     *
     * @example <caption>How to attach event handlers to a collapsing element</caption>
     * <div id="collapsing-element" class="collapsable">
     *   <p class="collapsing-title">This expands and collapses the content</p>
     *   <p class="collapsing-content">This is the collapsing content</p>
     * </div>
     * <script type="text/javascript">
     *   $('#collapsing-element').on('<%= jsnamespace %>.collapsables.start', function(e,show){
     *     // this refers to the .collapsable element
     *     console.log('This element will now be ' + (show===true ? 'expanded' : 'collapsed') + '.');
     *   });
     *   $('#collapsing-element').on('<%= jsnamespace %>.collapsables.start_item', function(e,item,show){
     *     // this refers to the .collapsable element
     *     // item refers to the .collapsing-content element
     *     console.log('This collapsing content element within .collapsable will now be ' + (show===true ? 'expanded' : 'collapsed') + '.');
     *   });
     *   $('#collapsing-element').on('<%= jsnamespace %>.collapsables.end_item', function(e,item,show){
     *     // this refers to the .collapsable element
     *     // item refers to the .collapsing-content element
     *     console.log('This collapsing content element within .collapsable has now been ' + (show===true ? 'expanded' : 'collapsed') + '.');
     *   });
     *   $('#collapsing-element').on('<%= jsnamespace %>.collapsables.end', function(e,show){
     *     // this refers to the .collapsable element
     *     console.log('This element has now been ' + (show===true ? 'expanded' : 'collapsed') + '.');
     *   });
     *   $('#collapsing-element').on('<%= jsnamespace %>.collapsables.running', function(e,show){
     *     // this refers to the .collapsable element
     *     console.log('This element is transformed so it will be ' + (show===true ? 'expanded' : 'collapsed') + ' in the end.');
     *   });
     * </script>
     */
    var Plugin = {},
        Options = {
            expandedClass : 'is--expanded',
            transitionClass : 'is--resizing',
            triggerSelector : '.collapsable__title',
            contentSelector : '.collapsable__content',
            defaultSpeed : 200
        },
        dataAttributeName = 'data-oe-collapsable',
        elements = [],
        events = {
            beforeExpand : OE.Utils.createCustomEvent('beforeExpand'),
            afterExpand : OE.Utils.createCustomEvent('afterExpand'),
            beforeCollapse : OE.Utils.createCustomEvent('beforeCollapse'),
            afterCollapse : OE.Utils.createCustomEvent('afterCollapse'),
            isExpanding : OE.Utils.createCustomEvent('isExpanding'),
            isCollapsing : OE.Utils.createCustomEvent('isCollapsing')
        };

    Plugin.init = function()
    {
        // Get the element, add a click listener...
        OE.Utils.delegateEvent(
            CLICK,
            docEventListener,
            '[' + dataAttributeName + '] *'
        );
    };

    var docEventListener = function(e)
    {
        var collapsable = getCollapsableElementFor(e.target),
            options = getOptionsFor(collapsable);

        if(OE.Utils.matches(e.target,options.triggerSelector))
        {
            Plugin.toggle(collapsable);
        }
    };

    var getOptionsFor = function(element)
    {
        return OE.Utils.getOptionsFromString(Options, element.getAttribute(dataAttributeName));
    };

    var getCollapsableElementFor = function(element)
    {
        while (element.parentElement && !element.hasAttribute(dataAttributeName))
        {
            element = element.parentElement;
        }

        return element;
    };

    var getTransitionspeedOfElement = function(element, fallbackDuration)
    {
        var transitionDuration = null,
            collapsable = getCollapsableElementFor(element),
            options = getOptionsFor(collapsable);

        try { transitionDuration = window.getComputedStyle(element).transitionDuration; } catch(ev) { }

        if(transitionDuration && !isNaN(parseFloat(transitionDuration)) && parseFloat(transitionDuration) >= 0)
        {
            if(transitionDuration.match(/[0-9\.]s$/))
            {
                transitionDuration = parseFloat(transitionDuration) * 1000;
            }
            else
            {
                transitionDuration = parseFloat(transitionDuration);
            }

            return Math.round(transitionDuration);
        }

        return fallbackDuration || options.defaultSpeed;
    };

    var getCollapsableElementsOf = function(collapsable)
    {
        var options = getOptionsFor(collapsable),
            elements = collapsable.querySelectorAll(options.contentSelector),
            element_count = elements.length,
            filtered = [];

        for(var i = 0; i < element_count; i++)
        {
            var _collapsable = getCollapsableElementFor(elements[i]);
            if(_collapsable === collapsable)
            {
                filtered.push(elements[i]);
            }
        }

        return filtered;
    };

    /**
     * @function resize
     * @protected
     * @param {string|object} collapsable - The DOM element that has to be resized
     * @param {bool} show - Show (expand) the element or not (collapse) ?
     * @param {number} speed - The speed (in ms) the animation should last
     *
     * @description Will resize {collapsable} when it is collapsed or collapse it when it is expanded. {@link resize} - this function
     */
    var resize = function(collapsable)
    {
        if(!collapsable)
        {
            return;
        }
        if(!OE.Utils.matches(collapsable,'[' + dataAttributeName + ']'))
        {
            return;
        }

        var options = getOptionsFor(collapsable),
            contents = null,
            show = typeof(arguments[1]) !== 'undefined' ? arguments[1] === true : !collapsable.classList.contains(options.expandedClass),
            speed = Math.max(0, parseInt(typeof(arguments[2]) !== 'undefined' ? arguments[2] : options.defaultSpeed));

        if(collapsable === null)
        {
            return false;
        }

        /** find the content to collapse/expand */
        contents = getCollapsableElementsOf(collapsable);

        if(!contents.length) {
            return false;
        }

        /** stop any running timeout */
        try { window.clearTimeout(collapsable.timer); } catch(ev) { }
        collapsable.dispatchEvent(events['before' + (show ? 'Expand' : 'Collapse')]);
        collapsable.classList.add(options.transitionClass);

        var endafter = 0;

        for(var i = 0; i < contents.length; i++)
        {
            var content = contents[i];

            content.dispatchEvent(events['before' + (show ? 'Expand' : 'Collapse')]);

            var to = show ? content.scrollHeight : 0,
                transitionSpeed = getTransitionspeedOfElement(content, speed);

            if(transitionSpeed > endafter) {
                endafter = transitionSpeed;
            }

            if(transitionSpeed > 0) {
                content.style.height = content.offsetHeight+'px';
            }

            if(show) {
                collapsable.classList.add(options.expandedClass);
            }
            else {
                collapsable.classList.remove(options.expandedClass);
            }

            if(transitionSpeed <= 0) {
                collapsableItemTimer.bind(collapsable, show, content)();

            }
            else {
                if(to <= 0) {
                    content.style.height = content.offsetHeight+'px';
                }

                if(!window.getComputedStyle(content)['transition-property'])
                {
                    content.hasTransition = false;
                }
                else {
                    content.hasTransition = true;
                }

                content.style.height = to+'px';

                content.collapsableTimer = window.setTimeout(collapsableItemTimer.bind(collapsable, show, content), transitionSpeed);
            }
        }

        if(endafter <= 0)
        {
            collapsableTimer.bind(collapsable, show)();
        }
        else {
            collapsable.interval = window.setInterval(collapsableInterval.bind(collapsable, show), 10);

            collapsable.timer = window.setTimeout(collapsableTimer.bind(collapsable, show), endafter+10);
        }
    };

    var collapsableInterval = function(show)
    {
        var options = getOptionsFor(this);

        if(this.classList.contains(options.transitionClass))
        {
            this.dispatchEvent(events['is' + (show ? 'Expanding' : 'Collapsing')]);
        }
    };

    var collapsableTimer = function(show)
    {
        var options = getOptionsFor(this);

        window.clearInterval(this.interval);
        this.classList.remove(options.transitionClass);
        this.dispatchEvent(events['after' + (show ? 'Expand' : 'Collapse')]);
    };

    var collapsableItemTimer = function(show, content)
    {
        var _this = this,
            options = getOptionsFor(_this),
            hcss 	= window.getComputedStyle(content).height,
            h		= parseInt(hcss),
            sh 		= content.scrollHeight;

        if(show) {
            content.style.height = 'auto';
        }

        hcss 	= window.getComputedStyle(content).height;
        h		= parseInt(hcss);
        sh 		= content.scrollHeight;

        content.dispatchEvent(events['after' + (show ? 'Expand' : 'Collapse')]);
    };

    /**
     * @function Collapsable~toggle
     * @param {string|object} element - The DOM element that has to be toggled - should be a collapsable element or one of its child objects
     * @param {number} speed - The speed (in ms) the animation should last
     *
     * @description Will expand {collapsable} when it is collapsed or collapse it when it is expanded. {@link resize}
     *
     * @example
     * // this will expand/collapse #collapsing-element with a 2 second long animation
     * OE.getPlugin('Collapsable').toggle(document.querySelector('#my-element', 2000);
     */
    Plugin.toggle = function(element)
    {
        var collapsable = getCollapsableElementFor(element),
            options = getOptionsFor(collapsable),
            speed = typeof(arguments[1]) !== 'undefined' && arguments[1] !== null ? Math.max(0, parseInt(arguments[1])) : null;

        if(collapsable === null) {
            return false;
        }

        if(collapsable.classList.contains(options.transitionClass))
        {
            return false;
        }

        if(collapsable.classList.contains(options.expandedClass))
        {
            Plugin.collapse(collapsable);
        }
        else
        {
            Plugin.expand(collapsable);
        }
    };

    /**
     * @function Collapsable~expand
     * @param {string|object} collapsable - The DOM element that has to be expanded - see {@link <%= jsnamespace %>.collapsables~toggle|toggle}
     * @param {number} speed - The speed (in ms) the animation should last
     *
     * @description Will expand {collapsable} if it is collapsed.
     *
     * @example
     * // this will expand #my-element with a 2 second long animation
     * OE.getPlugin('Collapsable').expand(document.querySelector('#my-element', 2000);
     *
     * // this will expand #my-element without any animation
     * OE.getPlugin('Collapsable').expand(document.querySelector('#my-element'));
     */

    Plugin.expand = function(element)
    {
        var collapsable = getCollapsableElementFor(element),
            options = getOptionsFor(collapsable),
            speed = typeof(arguments[1]) !== 'undefined' && arguments[1] !== null ? Math.max(0, parseInt(arguments[1])) : null;

        if(collapsable === null) {
            return false;
        }

        resize(collapsable, true, speed);
    };

    /**
     * @function Collapsable~collapse
     * @param {string|object} collapsable - The DOM element that has to be toggled - see {@link Collapsable~toggle|toggle}
     * @param {number} speed - The speed (in ms) the animation should last
     *
     * @description Will collapse {collapsable} if it is expanded.
     *
     * @example
     * OE.getPlugin('Collapsable').collapse(document.querySelector('#my-element'));
     */
    Plugin.collapse = function(element)
    {
        var collapsable = getCollapsableElementFor(element),
            options = getOptionsFor(collapsable),
            speed = typeof(arguments[1]) !== 'undefined' && arguments[1] !== null ? Math.max(0, parseInt(arguments[1])) : null;

        if(collapsable === null) {
            return false;
        }

        resize(collapsable, false, speed);
    };

    return Plugin;
})());
